export default __webpack_public_path__ + "static/media/photo--sm--23.1ac8947c.jpg";